<!--
 * @Author: Viviyaaaa 870951135@qq.com
 * @Date: 2024-04-12 10:05:08
 * @LastEditors: Viviyaaaa 870951135@qq.com
 * @LastEditTime: 2024-04-13 20:02:06
 * @FilePath: \demo\src\pages\type\style\Flat.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="flat-box">
    <img class="ditu" :src="require('@/assets/images/houseType/huxingluowei.jpg')" alt="">
    <ul v-if="isShow" class="tab-box">
      <li  v-for="(item,idx) in typeList"  :key="item.title" @click="getCurTab(item,idx)">
          <img  :src="selectIdx === idx? require('@/assets/images/houseType/' + item.selectIcon): require('@/assets/images/houseType/' + item.icon)" alt="" >
      </li>
    </ul>
    <div class="swiper">
      <ul class="swiper-wrapper">
        <li class="swiper-slide" v-for="(item,idxs) in imgList" :key="idxs">
          <img  :src="require('@/assets/images/houseType/'+item)" alt="" style="width: 100%;height:100%">
            <div class="upSwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" >
                  <img :src="require('@/assets/images/houseType/' + typeList[selectIdx].img)" alt="" style="width: 100%;height:100%;">
                </div>
                <div class="swiper-slide">
                  <img  :src="require('@/assets/images/houseType/hxjs_alpha.png')" alt="">
                </div>    
              </div>
            </div>
        </li>
     </ul>
    </div>
  </div>
</template>

<script >
import Swiper from 'swiper';
import '@/swiper/swiper-bundle.min.css';
export default{
  name: 'HouseSavor',
  data(){
    return {
      typeList:[
        {icon:'89.png', selectIcon:'89_1.png', img:'89.jpg'},
        {icon:'120.png', selectIcon:'120_1.png', img:'120.jpg'},
        {icon:'129.png', selectIcon:'129_1.png', img:'129.jpg'},
        {icon:'169.png', selectIcon:'169_1.png', img:'169.jpg'}
      ],
      imgList:['89luowei.jpg', '120luowei.jpg', '129luowei.jpg', '169luowei.jpg',],
      selectIdx:0,
      isShow: false
    }
  },
  mounted() {
    var that = this
    this.swiper = new Swiper(".swiper", {
      on: {
        slideChange: function(){
          that.selectIdx = this.activeIndex 
        },
        }
    });

    this.swipers = new Swiper(".upSwiper", {
      on: {
        slideChange: function(){
          if(this.activeIndex === 0) {
            that.isShow = false
          }else {
            that.isShow = true
          }
        },   
      },
      direction: "vertical",
      initialSlide: 1,
			slidesPerView: 1,
			spaceBetween: 0,
			lazy: {
				loadPrevNext: true,
			},
    });
  },
  methods:{
    getCurTab(item,idx){
      this.selectIdx = idx
      this.swiper.slideTo(idx);
      
    }
  }
}
</script>

<style lang="scss" scoped>
.flat-box {
  overflow: hidden;
  position: absolute;
  height: 100vh;
  width:100vw;
  background-color: #fff;
  .ditu {
    height: 100vh;
    width:100vw;
  }
  :deep(.upSwiper) {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
  }
  .tab-box {
    display: flex;
    position: absolute;
    z-index: 9;
    left: 6%;
    top: 10%;
    li {
      display: flex;
      justify-content: center;
      align-items: center;
      width:5rem;
      height:2rem;
      border-radius: 0.8rem;
      color: #fff;
      font-size: 0.5rem;
      img {
        width:80%;
      }

    }

  }
  :deep(.swiper){
    position: absolute;
    left:0;
    top: 0;
    width: 100vw; 
    height: 100vh; 
 
  }

}

</style>
